import { BLOCK_TYPES } from "../../common";
import { isValidCallbackDragArrangeList } from "../DragArrangeList";

const { DRAG_EXPAND_NUMBER_BLOCK } = BLOCK_TYPES;

const isValidCallback = (props: any) =>
    isValidCallbackDragArrangeList({
        ...props,
        blockType: DRAG_EXPAND_NUMBER_BLOCK,
    });

export default isValidCallback;
